<template>
  <div class="casesPage">
    <head-top></head-top>
    <div class="banner">
      <h3>行业资讯</h3>
      <p>商鼎云持续在电商领域深耕</p>
    </div>
    <div class="casesNav">
      <ul>
        <li :class="{'current':'' == typeObjId}" @click="onTypeChange('')">全部</li>
        <li v-for="(item, index) in articleTypeList" :key="index" :class="{'current':item.objId == typeObjId}" @click="onTypeChange(item.objId)">{{item.name}}</li>
      </ul>
    </div>
    <section class="newsContent">
      <div class="newsListBox">
        <div class="newsList" v-for="(item,index) of newsList" :key="index" @click="openJump('/newsDetails?objId='+item.objId)">
          <z-image class="newsImg" v-if="item.img && item.img.length > 0" :src="item.img[0]" />
          <div class="releaseName">
            {{item.createTime}}<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;阅读量：{{item.numVisit}}</span><span v-if="item.author">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;编辑：{{item.author}}</span>
          </div>
          <h3>{{item.title}}</h3>
          <p>{{item.introduce}}</p>
          <div class="but">
            <button @click="openJump('/newsDetails?objId='+item.objId)">阅读详情</button>
          </div>
        </div>
        <z-page :total="total" :currentPage="pageSize" @current-change="pageChange" :totalPage="7" :last="false"></z-page>
      </div>
      <div class="recommend">
        <div class="title">更多流行资讯</div>
        <div class="recommendList" v-for="(item, index) in recommendList" :key="index" @click="openJump('/newsDetails?objId='+item.objId)">
          <z-image class="newsImg" v-if="item.img && item.img.length > 0" :src="item.img[0]" />
          <h3>{{item.title}}</h3>
        </div>
      </div>
    </section>
    <foot-guide></foot-guide>
  </div>
</template>
<script>
import zPage from "@/components/common/page";
export default {
  components: {
    zPage
  },
  data() {
    return {
      articleTypeList: [],
      recommendList: [],
      newsList: [],
      typeObjId: "",
      //当前页码
      pageSize: 1,
      //总页数
      total: 1,
    };
  },
  created() {
    this.pageData();
    this.pageChange();
  },
  methods: {
    onTypeChange(val) {
      this.typeObjId = val;
      this.pageChange(1);
    },
    pageData() {
      this.$ajax
        .get("api/article/v1/classify")
        .then(data => {
          this.articleTypeList = data;
        });
      this.$ajax
        .post("api/article/v1/list", {
          pageNo: 1,
          pageSize: 5,
          type: 3003
        })
        .then(data => {
          this.recommendList = data.data;
        });
    },
    pageChange(size) {
      if (size) {
        this.pageSize = size;
      }
      this.$ajax
        .post("api/article/v1/list", {
          pageNo: this.pageSize,
          pageSize: 10,
          classifyId: this.typeObjId
        })
        .then(data => {
          this.newsList = data.data;
          this.total = data.pages;
          setTimeout(() => {
            document.documentElement.scrollTop = "0px";
          }, 100);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "src/style/mixin";
.casesPage {
  background-color: #fff;
}
.banner {
  background-image: url("https://qn.kemean.cn/upload/201809/06/f67ff4c2c26c4981a17ef634686b5043");
}
@media screen and (min-width: 1200px) {
  .casesNav {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    ul {
      display: flex;
      li {
        height: 80px;
        line-height: 80px;
        border-bottom: 3px solid #fff;
        font-size: 18px;
        color: #666666;
        margin-left: 40px;
        padding: 0px 11px;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
        &.current {
          border-bottom: 3px solid #345a9e;
          color: #345a9e;
        }
      }
    }
  }
  .newsContent {
    padding: 50px 0px;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .newsListBox {
      width: 773px;
      .newsList {
        margin-bottom: 80px;
        .newsImg {
          height: 300px;
          width: 100%;
        }
        .releaseName {
          margin-top: 20px;
          font-size: 14px;
          color: #666666;
        }
        h3 {
          font-size: 18px;
          color: #333333;
          margin-top: 16px;
        }
        p {
          font-size: 14px;
          color: #666666;
          margin-top: 16px;
        }
        button {
          width: 150px;
          height: 45px;
          background-color: #345a9e;
          border-radius: 8px;
          font-size: 14px;
          color: #ffffff;
          margin-top: 20px;
        }
      }
    }
    .recommend {
      width: 270px;
      .title {
        font-size: 16px;
        color: #333333;
        margin-bottom: 20px;
      }
      .recommendList {
        margin-bottom: 30px;
        .newsImg {
          height: 180px;
          width: 100%;
        }
        h3 {
          font-size: 16px;
          color: #333333;
          margin-top: 10px;
        }
      }
    }
  }
}
@media screen and (min-width: 750px) and (max-width: 1200px) {
  .casesNav {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    ul {
      display: flex;
      li {
        height: 8vw;
        line-height: 8vw;
        border-bottom: 3px solid #fff;
        font-size: 2vw;
        color: #666666;
        margin-left: 4vw;
        padding: 0px 11px;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
        &.current {
          border-bottom: 3px solid #345a9e;
          color: #345a9e;
        }
      }
    }
  }
  .newsContent {
    padding: 50px 10px;
    max-width: 1220px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .newsListBox {
      width: 68%;
      .newsList {
        margin-bottom: 80px;
        .newsImg {
          height: 25vw;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .releaseName {
          margin-top: 20px;
          font-size: 14px;
          color: #666666;
        }
        h3 {
          font-size: 2vw;
          color: #333333;
          margin-top: 16px;
        }
        p {
          font-size: 1.4vw;
          color: #666666;
          margin-top: 16px;
        }
        button {
          width: 14vw;
          height: 4.5vw;
          background-color: #345a9e;
          border-radius: 8px;
          font-size: 1.4vw;
          color: #ffffff;
          margin-top: 20px;
        }
      }
    }
    .recommend {
      width: 22%;
      .title {
        font-size: 16px;
        color: #333333;
        margin-bottom: 20px;
      }
      .recommendList {
        margin-bottom: 30px;
        .newsImg {
          height: 15vw;
          img {
            width: 100%;
            height: 100%;
          }
        }
        h3 {
          font-size: 1.6vw;
          color: #333333;
          margin-top: 10px;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .casesNav {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    ul {
      display: flex;
      li {
        height: 12vw;
        line-height: 12vw;
        border-bottom: 3px solid #fff;
        font-size: 3.8vw;
        color: #666666;
        margin-left: 4vw;
        padding: 0px 1.5vw;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
        &.current {
          border-bottom: 3px solid #345a9e;
          color: #345a9e;
        }
      }
    }
  }
  .newsContent {
    padding: 5vw 2vw;
    width: 100%;
    .newsListBox {
      width: 100%;
      .newsList {
        margin-bottom: 10vw;
        .newsImg {
          height: 30vw;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .releaseName {
          margin-top: 2vw;
          font-size: 3vw;
          color: #999;
          span {
            color: #999;
          }
        }
        h3 {
          font-size: 4vw;
          color: #333333;
          margin-top: 1.6vw;
        }
        p {
          font-size: 1.4vw;
          color: #666666;
          margin-top: 1.6vw;
          display: none;
        }
        .but {
          display: flex;
          justify-content: center;
          margin-top: 2vw;
          button {
            width: 22vw;
            height: 7vw;
            background-color: #345a9e;
            border-radius: 1vw;
            font-size: 1.4vw;
            color: #ffffff;
          }
        }
      }
    }
    .recommend {
      width: 100%;
      display: none;
      .title {
        font-size: 1.6vw;
        color: #333333;
        margin-bottom: 20px;
      }
      .recommendList {
        margin-bottom: 30px;
        .newsImg {
          height: 15vw;
          img {
            width: 100%;
            height: 100%;
          }
        }
        h3 {
          font-size: 1.6vw;
          color: #333333;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
